import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Weddings from "./pages/Weddings";
import Birthday from "./pages/BirthdayGallery";
import Womensday from "./pages/events/Womensday";
import Cradle from "./pages/events/Cradle";
import EventGalleryPage from "./components/EventGalleryPage";
import cloudinaryEvents from "./data/cloudinaryEvents.json";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import Rentals from "./pages/Rentals";
import Testimonials from "./pages/Testimonials";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/weddings" element={<Weddings />} />
          <Route path="/rentals" element={<Rentals />} />
          <Route path="/events/birthday" element={<Birthday />} />
          <Route path="/events/womensday" element={<Womensday />} />
          <Route path="/events/cradle" element={<Cradle />} />
          {cloudinaryEvents.map(({ slug, folder, label, intro }) => (
            <Route key={slug} path={`/events/${slug}`} element={
              <EventGalleryPage cloudinaryFolder={folder} imageLabel={label} intro={intro} />
            } />
          ))}
          <Route path="/testimonials" element={<Testimonials />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
